export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.a5aa14fc.worker.js");
}
